import { render, staticRenderFns } from "./BagLabel.vue?vue&type=template&id=32021086&scoped=true&"
import script from "./BagLabel.vue?vue&type=script&lang=js&"
export * from "./BagLabel.vue?vue&type=script&lang=js&"
import style0 from "./BagLabel.vue?vue&type=style&index=0&id=32021086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32021086",
  null
  
)

export default component.exports